import { useState, useEffect, useRef } from "react";
import Keyboard from "react-simple-keyboard";
import {
  Modal,
  Popover,
  Row,
  Col,
  Card,
  Progress,
  Table,
  Divider,
  Drawer,
  Button,
  Input,
  Menu,
  Spin,
  Badge,
  message,
  Select,
  DatePicker,
  Form,
  Tabs,
  Checkbox,
  Calendar,
  Switch,
  AutoComplete,
} from "antd";
import {
  CalendarOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  CloseOutlined,
  LoadingOutlined,
  CloseSquareFilled,
  RightOutlined,
  DownOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  CheckOutlined,
  AppstoreOutlined,
  PlusOutlined,
  MinusOutlined,
  CarOutlined,
  GiftOutlined,
  CodeSandboxOutlined,
  ReloadOutlined,
  ArrowsAltOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import db from "../../../database";
import styles from "../../../constants/styles.json";
import BarCodeComponentForRetail from "../../../lib/BarCodeComponentForRetail";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { useWindowDimensions } from "../../../lib/useViewport";
import CWPoleDisplay from "../../../lib/printer/CWPoleDisplay";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import { useGlobalContext } from "../../../lib/auth/globalStore";
import CWEstimatePrinter from "../../../lib/printer/CWEstimatePrinter";
import { processSync } from "../../Sync/syncData";
import ProductPanelSM from "../../../components/PointOfSale/Retail/productPanelSM";
import { discardCouponService, discardGiftCard, getProductsNearbyStockService, upsertGiftCardTransaction, verifyReturn, unlinkTill } from "../../../services";
import sideMenu from "../../../assets/images/side-menu.svg";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../assets/images/lock-icon.svg";
import userIcon from "../../../assets/images/userId.svg";
import Ofline from "../../../assets/images/red.svg";
import Online from "../../../assets/images/green.svg";
import Close from "../../../assets/images/close-x.svg";
import Logout from "../../../assets/images/logout-new.svg";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import ScanIcon from "../../../assets/images/scanIcon.svg";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import NotesAdd from "../../../assets/images/note-add.svg";
import userTieIcon from "../../../assets/images/userTieIcon.svg";
import Offers from "../../../assets/images/promoTag.svg";
import NotesImage from "../../../assets/images/notes.svg";
import Hold from "../../../assets/images/pause-new.svg";
import Cancel from "../../../assets/images/cancel-new.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import userAddIcon from "../../../assets/images/userAddIcon.svg";
import CustomerSearch from "../../../assets/images/c-serach.svg";
import CustomerIcon from "../../../assets/images/customer1.svg";
import View from "../../../assets/images/view.svg";
import AddUser from "../../../assets/images/userAdd.svg";
import SyncIcon from "../../../assets/images/syncIcon.svg";
import information from "../../../assets/images/information.svg";
import discount from "../../../assets/images/discount.svg";
import ReturnIcon from "../../../assets/images/return.svg";
import SalesHistoryIcon from "../../../components/PointOfSale/Retail/SvgComponent/SalesHistoryIcon";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import user_add from "../../../assets/images/user_add.svg";
import Back from "../../../assets/images/backIcon.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import ticSelect from "../../../assets/images/tic.png";
import Loyality from "../../../assets/images/loyalityIcon.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import Gift from "../../../assets/images/giftIcon.svg";
import Credit from "../../../assets/images/creditCardIcon.svg";
import cardType from "../../../assets/images/cardType.svg";
import creditNote from "../../../assets/images/creditNote.svg";
import POSIcon from "../../../components/PointOfSale/Retail/SvgComponent/POS";
import ParkedBillIcon from "../../../components/PointOfSale/Retail/SvgComponent/ParkedBill";
import CashManagementIcon from "../../../components/PointOfSale/Retail/SvgComponent/CashManagementIcon";
import GroupedProducts from "../../../lib/hooks/GroupedProducts";
import RetailModals from "../../PointOfSale/Retail/RetailModals";
import LoadingScreen from "../../PointOfSale/Retail/SuperMarket/LoadingScreen";
import leftLoading from "../../../assets/images/opo.gif";
import { clock } from "../../../utility/clock";
import SyncSide from "../../../assets/images/sideFullSync.svg";
import openDrawerIcon from "../../../assets/images/openDrawer.svg";
import unlinkTillIcon from "../../../assets/images/unlink-icon.svg";
import { useHistory } from "react-router-dom";
import RenderInput from "../../../lib/hooks/RenderInput";
import messages from "../../../errors/messages.en-IN.json";

const SupermarketEstimate = (props) => {
  const {
    showSaleType,
    setShowSaleType,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    selectedSaleType,
    setSelectedSaleType,
    tillData,
    clearProductSearchResults,
    setProductSearchInput,
    productSearchInput,
    open,
    setOpen,
    inputName,
    setInputName,
    setIsInputFocused,
    isInputFocused,
    productSearchInputRef,
    onBarcodeInput,
    setIsProductsFilter,
    setFilterDrawer,
    documentTypes,
    selectedDocumentType,
    setSelectedDocumentType,
    showDocumentPopup,
    setShowDocumentPopup,
    notesValue,
    setNotesValue,
    selectedProductInCart,
    setSelectedProductInCart,
    selectProductInCart,
    showPaymentMethods,
    setShowPaymentMethods,
    selectedRowKeys,
    setSelectedRowKeys,
    deleteProduct,
    customMixItems,
    setCustomMixItems,
    groupQty,
    setGroupQty,
    selectedProductForNotes,
    setSelectedProductForNotes,
    openSalesRep,
    setOpenSalesRep,
    realPrice,
    setRealPrice,
    firstInputValue,
    setFirstInputValue,
    selectedCustomMix,
    setSelectedCustomMix,
    existingGroupItems,
    setExistingGroupItems,
    setOverPayedAmount,
    overPayedAmount,
    amount,
    setAmount,
    setQtyNumberFlag,
    setStockList,
    stockList,
    keyboard,
    clearSelectedProductInCart,
    verifyStock,
    openDisplayParkedBillModal,
    filterDrawer,
    couponModalVisible,
    displayAddNewCustomer,
    validateGiftCard,
    displayCustomerSearch,
    displayEditOldCustomer,
    giftCardFlag,
    setGiftCardFlag,
    isGiftCardFlag,
    manualDiscountModalVisible,
    loyalityOtpModalVisible,
    cart,
    setDisplayCustomerSearch,
    setCloseCustomerFlag,
    setEditFlag,
    removeCutomer,
    showAddNewCustomerFields,
    showEditOldCustomerFields,
    manualDiscountForm,
    setManualDiscountInput,
    setSelectedManualDiscountTypeValue,
    setManualDiscountModalVisible,
    setIsGiftCardFlag,
    setAddToBagFlag,
    giftCardType,
    setGiftCardType,
    searchHistoryInput,
    setSearchhistoryInput,
    orderHistoryDetails,
    setOrderHistoryDetails,
    filtersFlag,
    setFiltersFlag,
    searchOrderHistory,
    modifyProductList,
    onChangeTotalQuantity,
    enterTotalQty,
    handleTotalQty,
    decreaseProductQty,
    increaseProductQty,
    handleRealPrice,
    enterRealPrice,
    showPayments,
    setShowPayments,
    setNumb,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    paymentModalInputRef,
    processOrder,
    paymentCardRef,
    filteredPaymentMethods,
    isShowingAll,
    setIsShowingAll,
    onChangeAmount,
    requestPayment,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    currenciesData,
    handleCashPayment,
    handleAmount,
    giftCardData,
    setGiftCardData,
    handleLoyaltyPayment,
    setCart,
    getFilteredPaymentMethods,
    setStartIndex,
    startIndex,
    setSelectedKeys,
    filterdParkedList,
    setFilterdParkedList,
    showOrderHistory,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    checkIsManualWeight,
    setIsSearchProducts,
    getMoreProducts,
    isProductsFilter,
    getSearchedProducts,
    productListCardRef,
    setIsProductsVisible,
    isProductsVisible,
    pickProduct,
    setKeyboardType,
    keyboardType,
    productsData,
    layoutName,
    setLayoutName,
    deleteCart,
    showCustomMix,
    setShowCustomMix,
    orderType,
    setOrderType,
    posSaleTypes,
    setPosSaleTypes,
    setCurrenciesData,
    closeProductPanel,
    isQtyUpdate,
    customerSearchInput,
    setCustomerSearchInput,
    form,
    keyboardInputFields,
    setKeyboardInputFields,
    options,
    setOptions,
    searchInputRef,
    activeInput,
    setActiveInput,
    deleteReceipt,
    loading,
    setLoading,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    setProductStock,
    cardPaymnetStatusPLB,
    setCardPaymnetStatusPLB,
  } = props;
  const { TabPane } = Tabs;
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const history = useHistory();
  const { globalStore, setGlobalStore } = useGlobalContext();
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = globalStore;
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const domainURL = process.env.REACT_APP_domain;
  const [tillLink, setTillLink] = useState(false);
  const productSearchRef = useRef(null);
  const productPanelSearchRef = useRef(null);
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  //   const [showCustomMix, setShowCustomMix] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLocked, setIsLocked] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  // const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cartObj")));
  const [notesPopup, setNotesPopup] = useState(false);
  const [showInputFields, setShowInputFields] = useState(false);
  const [groupName, setGroupName] = useState("Custom Mix");
  const [returnFlag, setReturnFlag] = useState(false);
  const [isPurchaseReturn, setIsPurchaseReturn] = useState(false);
  const [isCashMangement, setIsCashManagement] = useState(false);
  const [isParkedBill, setIsparkedBill] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [showReturnPurchase, setShowReturnPurchase] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [viewStock, setViewStock] = useState(false);
  const [keyValue, setKeyValue] = useState("0");
  const [syncLoad, setSyncLoad] = useState(false);
  const [productItems, setProductItems] = useState([]);
  const [productArray, setProductArray] = useState();
  const [productsDisplay, setProductDisplay] = useState("super-market");
  const estimateNumber = Number(localStorage.getItem("estimateNo") || 1);
  const [estimateNo, setEstimateNo] = useState(estimateNumber);
  const [productsList, setProductsList] = useState([]);
  const [clock1, setClock1] = useState(clock());
  const [productMap, setProductMap] = useState({});
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);
  const qtyInputRef = useRef(null);
  // const searchInputRef = useRef(null);
  const genericUrl = process.env.REACT_APP_genericUrl;
  const retailUrl = process.env.REACT_APP_serverUrl;
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const version_number = process.env.REACT_APP_release_no || "24Q0.0.0";
  const { access_token, username, authHeaders } = getOAuthHeaders();
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const customerId = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId;
  const tillAccessData = tillData?.tillAccess;
  const showVirtualKeyboard = posConfig?.showKeyboard === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
    });
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (cardPaymnetStatusPLB) {
      Modal.info({
        icon: null,
        // centered: true,
        okButtonProps: { style: { display: "none" } },
        okText: "Go Back",
        content: (
          <div
            style={{
              fontSize: "18px",
              fontWeight: "500",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 0,
              fontSize: "1vw",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "58px",
                height: "58px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 165, 0, 0.2)",
                marginTop: "15px",
              }}
            >
              <ExclamationCircleOutlined
                style={{
                  fontSize: "35px",
                  color: "orange",
                }}
              />
            </div>
            <p style={{ color: "#0F0718", fontWeight: 550, fontSize: "1.8em", padding: "15px 15px 0 15px", marginBottom: 0 }}>Payment Timed Out</p>
            <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "5px 20px 0 20px" }}>
              Your payment request couldn't be processed in time. Please try again
            </p>

            <button
              style={{
                backgroundColor: "#2F3856",
                color: "#fff",
                // padding: "10px",
                padding: "10px 50px 10px 50px",
                borderRadius: "10px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => {
                setCardPaymnetStatusPLB(false);
                Modal.destroyAll();
              }}
            >
              Try Again
            </button>
          </div>
        ),
        style: {
          textAlign: "center",
          height: "50vh",
          width: "50%",
        },
        modalRender: (modal) => <div style={{ borderRadius: "12px", overflow: "hidden" }}>{modal}</div>,
        bodyStyle: {
          padding: "0",
        },
        closable: false,
        onOk: null,
      });
    }
  }, [cardPaymnetStatusPLB]);

  useEffect(() => {
    setTimeout(() => {
      try {
        const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
        if (cartDetails !== null) {
          setCart(cartDetails);
        }
      } catch (error) {
        console.error("Error parsing cart details:", error);
      }
    }, 200);

    setTimeout(() => {
      setProductSearchInput("");
      const productSearchInput = document.getElementById("sm-product-search");
      if (productSearchInput) {
        productSearchInput.blur();
      }
      keyboard?.current?.setInput("");
    }, 200);
  }, []);

  const updateKeyboardInputs = async (inputs) => {
    if (!inputs) return;
    if (inputName === "customerSearch") setCustomerSearchInput(inputs?.customerSearch || "");
    // if (inputName === "productSearch") setProductSearchInput(inputs?.productSearch || "");
    if (inputName === "productSearch") {
      const searchValue = inputs?.productSearch || inputs?.productSearch1 || "";
      setProductSearchInput(searchValue);
      await handleSearch(searchValue);
    }
    if (inputName === "productSearch1") setProductSearchInput(inputs?.productSearch1 || "");
    if (keyboardInputFields?.type === "addCustomerForm" || keyboardInputFields?.type === "editCustomerForm" || keyboardInputFields?.type === "UAECustomerForm") {
      const customerObj = form?.getFieldsValue(true) || {};
      const updatedFields = {
        ...customerObj,
        ...inputs,
      };
      setKeyboardInputFields(updatedFields);
      form?.setFieldsValue(updatedFields);
    }
  };

  const onKeyPress = (button) => {
    const productSearchInput = document.getElementById("sm-product-search");
    if (button === "{enter}") {
      setLayoutName("default");
      switch (inputName !== "") {
        case inputName === "salesHistoryInput":
          const inputValue = searchHistoryInput;
          if (inputValue !== "") {
            searchOrderHistory("customer", inputValue, 0, dateRange?.length > 0);
          }
          break;
        case inputName === "productSearch":
          onBarcodeInput(productSearchInput.value, true);
          // getSearchedProducts();
          break;
        case inputName === "productSearch1":
          handleSelectProduct();
        default:
          // Handle the default case or do nothing
          break;
      }
    } else if (button === "{number}") {
      setLayoutName("number");
    } else if (button === "{numbers}") {
      setLayoutName("numbers");
    } else if (button === "{caps}") {
      setLayoutName("default");
    } else if (button === "{small}") {
      setLayoutName("shift");
    } else if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const handleShift = () => {
    layoutName === "default" ? setLayoutName("shift") : setLayoutName("default");
  };

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  const mainDivStyles = themeJSON.appBgImageURL
    ? { backgroundImage: `url(${themeJSON.appBgImageURL})`, height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" }
    : { backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" };
  document.querySelectorAll("amt-dial-btn-market").forEach((element) => {
    element.style.backgroundColor = themeJSON.keyBoardColor;
  });

  const showPreviousItems = () => {};

  const handleCancel = () => {
    // Handle the cancel action here
    Modal.destroyAll();
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const handleSelectProduct = async () => {
    await db.products
      .filter((product) => product.isactive === true)
      .toArray()
      .then((productsFetched) => {
        const lowerCaseSearchInput = productSearchInput.toLowerCase();
        const filteredProducts = productsFetched.filter(
          (product) =>
            product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
            product?.batchIndex === lowerCaseSearchInput ||
            product?.upcIndex === lowerCaseSearchInput ||
            product?.value === lowerCaseSearchInput ||
            product?.upc === lowerCaseSearchInput
        );
        if (filteredProducts.length === 0) {
          {
            message.info(`${t("product_search_category_error")}`);
          }
        } else {
          setProductsList(filteredProducts);
        }
      });
  };

  useEffect(async () => {
    if (cart.items.length === 0 && cart.payments.length > 0) {
      await cart.payments.map(async (payment) => {
        handleDeletePayment(payment);
      });
    }
  }, [cart]);

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          let setAuthTokens;
          if (authHeaders && authHeaders.access_token) {
            setAuthTokens = authHeaders.access_token;
          }
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: cart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));

          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
            cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
            type: "${detail.type}",
            referenceNo: "${detail.referenceNo}",
            amount: ${detail.amount},
            cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
          }`
          );

          const data = {
            query: `
                mutation {
                  upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                    status
                    message
                  }
                }`,
          };

          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "loyalty" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, cart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        // Filter out undefined results (where payment name matched)
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        localStorage.setItem("cartObj", JSON.stringify(cart));
        setCart(cart);
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  const handleKeyvalue = async (key) => {
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item, index) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }

    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }

    if (key === "4") {
      setSyncLoad(true);
      let tillData = JSON.parse(localStorage.getItem("tillData"));
      // const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : defaultCustomer;
      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillData.tillAccess.csBunit.b2cCustomer;
      setCart({ ...cart, customer: defaultCustomer });
      await processSync(tillData, setGlobalStore, "Incremental Sync");
      setSyncLoad(false);
      setGlobalStore({ percent: "0%" });
      setGlobalStore({ productCategoryPercentage: "0" });
      setGlobalStore({ productPercentage: "0" });
      setGlobalStore({ promotionPercentage: "0" });
      // window.location.reload();
    }

    if (key === "7") {
      setKeyValue("7");
      setSelectedKeys([]);
    }

    if (key === "parked-bill") {
      filterdParkedList?.map((item, index) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
    }
  };
  const showConfirm = () => {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* Bill Amount Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Tendered Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {parseFloat(amount).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Amount Received Row */}
            <Row
              style={{
                fontSize: "1em", // Adjust font size for readability
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}
                </p>
              </Col>
            </Row>

            {/* Change Row */}
            <Row
              style={{
                fontSize: "1em",
                width: "100%",
              }}
            >
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "right",
                  justifyContent: "end",
                }}
              >
                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "400",
                    color: "#0F0718",
                  }}
                >
                  {cart.paid + parseFloat(amount) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the Cancel button
          },
        },
        okButtonProps: {
          style: {
            borderRadius: "5px", // Border radius for the OK button
          },
        },
      });
    });
  };

  const showMoreItems = () => {
    const PaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
    let paymentDetails = getFilteredPaymentMethods();
    if (
      cart?.docType === "Advance" &&
      posConfig?.allowLayawaywithoutPayment !== "Y" &&
      !cart.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
    ) {
      paymentDetails = [
        ...paymentDetails,
        {
          cWRPaymentMethodID: "",
          sequenceNo: 9999,
          finPaymentmethodId: "",
          finFinancialAccountId: "",
          finDayCloseAccountId: null,
          name: "Complete Order",
          integratedPayment: false,
          isloyalty: false,
          paymentProvider: null,
          iscredit: false,
          isGiftCard: false,
          isDefault: "N",
          csCurrencyId: "",
          isoCode: "AED",
          isactive: true,
          salesType: [],
        },
      ];
    }
    let itemsPerPage =
      tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5;
    if (startIndex + itemsPerPage >= paymentDetails.length) {
      if (startIndex < paymentDetails.length) {
        setShowPayments(paymentDetails.slice(startIndex, paymentDetails.length));
        setStartIndex(paymentDetails.length);
      } else {
        setShowPayments(paymentDetails.slice(0, itemsPerPage));
        // setStartIndex(4);
        setStartIndex(itemsPerPage);
      }
    } else {
      setShowPayments(paymentDetails.slice(startIndex, itemsPerPage + startIndex));
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const confirmUnlink = () => {
    Modal.confirm({
      title: "Confirm Unlink",
      content: "Are you sure you want to unlink the till?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: async () => {
        await tillUnlink(); // Perform the unlink operation on confirmation
      },
      onCancel: () => {
        console.log("Unlink operation cancelled");
      },
    });
  };

  const tillUnlink = async () => {
    const unlinkTillAPI = async () => {
      try {
        let id = tillData.tillAccess.cwrTill.cwrTillID; // Ensure `tillData` is defined and accessible
        const response = await unlinkTill(id);

        if (response.data.data.unlinkTill.status === "200") {
          const keepKey = ""; // Specify any keys to retain if needed
          localStorage.clear(); // Clear local storage

          // Clear IndexedDB tables
          await Promise.all(
            db.tables.map(async (table) => {
              if (table.name !== keepKey) {
                await table.clear();
              }
            })
          );
        }

        document.cookie.split(";").forEach((cookie) => {
          document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`);
        });

        localStorage.removeItem("unlink"); // Remove specific item
        window.location.assign(`${redirectUrl}sign-in`); // Redirect to SSO URL
      } catch (error) {
        console.error("Error in unlinkTillAPI:", error);
      }
    };

    await unlinkTillAPI(); // Await the internal API call
  };

  const getProductNearByStock = async () => {
    let setAuthTokens;
    if (authHeaders && authHeaders.access_token) {
      setAuthTokens = authHeaders.access_token;
    }
    try {
      const stockInputValues = {
        query: `
          query {
            getProductsNearbyStock(
              bUnitId: "${tillData.tillAccess.csBunit.csBunitId}",
              code: "${selectedProductInCart.value}"
            ) {
              csBunitId
              value
              name
              totalQty
              stores {
                csNearbyStoreId
                name
                nearbybUnitId
                viewStock
                isIssue
                warehouse {
                  mWarehouseID
                  name
                  value
                  storageBin {
                    mStoragebinID
                    name
                    stocks {
                      mStockID
                      qtyonhand
                      product {
                        mProductId
                        value
                        name
                        upc
                        uom {
                          csUomId
                          name
                        }
                        productCategory {
                          mProductCategoryId
                          value
                          name
                        }
                      }
                      batch {
                        mBatchId
                        batchno
                        upc
                        price
                        startdate
                        enddate
                        life
                      }
                    }
                    totalQty
                  }
                }
              }
            }
          }
        `,
      };

      const response = await getProductsNearbyStockService(stockInputValues);

      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;

      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: "79FD0E516E4F4C5F9A7932F0C5C82C92",
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: {
            mStoragebinID: "09581CA09C154830A20B88370C501FD6",
            name: "Central Warehouse",
            stocks: [],
            totalQty: totalQty || 0,
          },
        },
      };

      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
    }
  };

  const handleViewStockClick = () => {
    getProductNearByStock();
    setViewStock(true);
  };

  const handleSearch = async (data) => {
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const search = data.toLowerCase();
    if (!data) {
      setOptions([]);
      return;
    }

    let products;

    if (posConfig?.is_smart_product_search === "Y") {
      products = await db.products
        .filter((product) => product.isactive === true)
        .filter((product) => product.value?.toLowerCase() === data)
        .limit(20)
        .toArray();

      if (products.length === 0) {
        products = await db.products
          .filter((product) => product.isactive === true)
          .filter((product) => {
            return product.upcIndex === data || product.upc === data || product.name?.toLowerCase().includes(search);
          })
          .limit(20)
          .toArray();
      }
    } else {
      products = await db.products
        .filter(product => product.isactive === true)
        .filter((product) => {
          return product.name?.toLowerCase().includes(search) || product.upcIndex === data || product.upc === data || product.value === data;
        })
        .limit(20)
        .toArray();
    }
    if (products.length > 0) {
      const filteredOptions = products.map((item) => ({
        label: `${item.value} - ${item.name}`,
        value: item.value,
      }));
      const map = {};
      products.forEach((item) => {
        map[item.value] = item;
      });
      setOptions(filteredOptions);
      setProductMap(map);
    } else {
      setOptions([]);
      setProductMap({});
    }
  };

  const onChangeInput = async (event) => {
    const inputVal = event.target.value;
    setProductSearchInput(inputVal);
    localStorage.setItem("productName", inputVal);
    keyboard?.current?.setInput(inputVal);
    if (posConfig?.product_search_display_mode === "dropdown") {
      if (inputVal.trim() === "") {
        setOptions([]);
        setProductMap({});
        return;
      }
      await handleSearch(inputVal);
    }
  };

  // const onChangeInput = async (event) => {
  //   const inputVal = event.target.value;
  //   // await handleSearch(inputVal);
  //   setProductSearchInput(inputVal);
  //   localStorage.setItem("productName", inputVal);
  //   keyboard?.current?.setInput(inputVal);
  // };

  const removeProductModal = (record) => {
    setShowCustomMix(false);
    deleteProduct(record);
    // if (productSearchInputRef.current) {
    //   productSearchInputRef.current.focus();
    //   const productSearchInput = document.getElementById("sm-product-search");
    //   if (productSearchInput) {
    //     productSearchInput.focus();
    //     productSearchInput.select();
    //   }
    // }
  };

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  let barcodeFlag = false;
  const inputElement = document.getElementById("sm-customer-search");
  const amountInput = document.getElementById("sm-amount-input");
  const totalAmountInout = document.getElementById("sm-total-amount-input");
  const inputFocused = inputElement === document.activeElement || amountInput === document.activeElement || totalAmountInout === document.activeElement;
  const approvalFlag = localStorage.getItem("approvalFlag") ? localStorage.getItem("approvalFlag") : "1";
  if (
    !couponModalVisible &&
    !displayAddNewCustomer &&
    !validateGiftCard &&
    !displayCustomerSearch &&
    !displayEditOldCustomer &&
    !giftCardFlag &&
    !filterDrawer &&
    !isGiftCardFlag &&
    !manualDiscountModalVisible &&
    !loyalityOtpModalVisible &&
    !inputFocused &&
    !showCustomMix &&
    approvalFlag === "1"
  ) {
    barcodeFlag = true;
  } else {
    barcodeFlag = false;
  }

  const cartItems = (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
    (item) => item.weight !== 0
  );
  const hasExpandableRows = cartItems.some((item) => item.children && item.children.length > 0);

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
      <>
        {!syncLoad ? (
          <div style={mainDivStyles}>
            <Row
              style={{
                padding: "0.8% 0",
                height: "9vh",
                alignItems: "center",
                fontSize: "1vw",
              }}
            >
              <Col
                onClick={() => {
                  setTillLink(true);
                }}
                style={{ cursor: "pointer" }}
                span={1}
              >
                <img src={sideMenu} style={{ paddingLeft: "1rem", height: "2vw" }} />
              </Col>
              <Col
                span={5}
                onDoubleClick={() => {
                  deleteReceipt(true);
                  history.push("/pos");
                }}
                style={{ cursor: "pointer" }}
              >
                <img src={themeJSON.logoURL || POSLogo} style={{ height: "2.5vw", paddingLeft: "0.4vw" }} />
              </Col>
              <Col
                span={2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {showSaleType === true ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#0F0718",
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "13px",
                      paddingLeft: "1vw",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (cart.layAway !== "Y") {
                        setIsSaleTypeFlag(true);
                      }
                    }}
                  >
                    {selectedSaleType}
                  </span>
                ) : (
                  ""
                )}
              </Col>
              <Col span={1} />
              <Col
                span={5}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1em",
                    color: themeJSON.dateTimeTextColor || "#929098",
                    marginLeft: "7vw",
                  }}
                >
                  {" "}
                  {formattedDateTime}
                </span>
              </Col>
              <Col
                span={2}
                style={{
                  textAlign: "center",
                  color: themeJSON.orderNoTextColor || "#0F0718",
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "1.1em",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  // let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
                  // if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
                  //   setShowDocumentPopup(true);
                  // }
                }}
              >
                {posConfig?.enableProductGrouping === "Y" && (
                  <CodeSandboxOutlined
                    style={{ fontSize: "18px", cursor: "pointer" }}
                    onClick={() => {
                      setShowCustomMix(true);
                      localStorage.setItem("customMix", "CM");
                      // localStorage.setItem("productSegment", "CB");
                    }}
                  />
                  // <img
                  //   src={GroupItemImg}
                  //   style={{ height: "6.5vh", width: "4vw", cursor: "pointer" }}
                  //   onClick={() => {
                  //     setShowCustomMix(true);
                  //     localStorage.setItem("customMix", "CM");
                  //     // localStorage.setItem("productSegment", "CB");
                  //   }}
                  // />
                )}
              </Col>
              <Col
                span={4}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingleft: "2vw",
                }}
              >
                {/* <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: themeJSON.orderNoTextColor || "#0F0718",
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1em",
                    paddingLeft: "1vw",
                  }}
                >
                  Order No:{cart?.documentno}
                </span> */}

                {/* <EditOutlined onClick={()=>{setNotesPopup(true); setIsInputFocused(true)}} style={{lineHeight:"3.5vh",fontSize:"1.5vw",cursor:"pointer"}}/> */}
              </Col>
              <Col
                span={5}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  // paddingRight: "1%",
                }}
              >
                {/* <img
                  src={NotesImage}
                  onClick={() => {
                    setNotesPopup(true);
                    if (cart.description && cart.description.trim() !== "") {
                      setNotesValue(cart.description);
                    }
                    setIsInputFocused(true);
                  }}
                  style={{
                    fontSize: "1.5vw",
                    cursor: "pointer",
                    height: "2.4vh",
                    marginRight: "0.7rem",
                  }}
                  alt=""
                /> */}

                <img
                  onClick={() => {
                    if (isOnline) {
                      setIsLocked(true);
                    } else {
                      errorMessage(`${messages.errors.sync.sync_failed}`, `${messages.errors.sync.network_error}`);
                    }
                  }}
                  src={LockIcon}
                  style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "center",
                    padding: "0.5vw",
                    border: "1px solid #3C424B",
                    borderRadius: "50%",
                  }}
                >
                  <img src={userIcon} style={{ height: "2.7vh" }} />
                </div>
                <div
                  style={{
                    marginLeft: "1vw",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span
                    style={{
                      color: themeJSON.orderNoTextColor || "#0F0718",
                      fontSize: "1em",
                      fontFamily: "Inter",
                      fontWeight: "500",
                      wordWrap: "break-word",
                    }}
                  >
                    {userData.user}
                  </span>
                  <span
                    style={{
                      color: themeJSON.orderNoTextColor || "#0F0718",
                      fontSize: "0.8em",
                      fontFamily: "Inter",
                      fontWeight: "500",
                      wordWrap: "break-word",
                    }}
                  >
                    Till ID : {JSON.parse(localStorage.getItem("tillValue"))?.name}
                  </span>
                </div>
                <div style={{ marginLeft: "3%" }}>
                  <img
                    src={Online}
                    style={{
                      display: !isOnline && "none",
                      height: "2.5vh",
                      cursor: "pointer",
                      paddingBottom: "0.5vh",
                    }}
                  />{" "}
                  <img
                    src={Ofline}
                    style={{
                      display: isOnline && "none",
                      height: "2.5vh",
                      cursor: "pointer",
                      paddingBottom: "0.5vh",
                    }}
                  />{" "}
                </div>
              </Col>
            </Row>
            {barcodeFlag && <BarCodeComponentForRetail onScan={onBarcodeInput} setProductSearchInput={setProductSearchInput} productSearchInput={productSearchInput} />}
            <div style={{ display: "flex", height: "91vh" }}>
              {/* Left side UI */}
              <div style={{ width: "63.9%" }}>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "0 0 0 1.7%",
                  }}
                >
                  <div style={{ width: "93%" }}>
                    <RenderInput
                      posConfig={posConfig}
                      options={options}
                      productMap={productMap}
                      pickProduct={pickProduct}
                      productSearchInput={productSearchInput}
                      setProductSearchInput={setProductSearchInput}
                      setOptions={setOptions}
                      keyboard={keyboard}
                      filterDrawer={filterDrawer}
                      searchInputRef={searchInputRef}
                      clearProductSearchResults={clearProductSearchResults}
                      onChangeInput={onChangeInput}
                      setOpen={setOpen}
                      setInputName={setInputName}
                      setIsInputFocused={setIsInputFocused}
                      onBarcodeInput={onBarcodeInput}
                      productSearchInputRef={productSearchInputRef}
                    />
                  </div>
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "4.5%",
                      margin: "0 0.2vw 0 0.8vw",
                      borderRadius: "7px",
                      height: "inherit",
                      borderColor: "#fff",
                    }}
                    onClick={() => setIsProductsFilter(true)}
                  >
                    <img src={ScanIcon} style={{ height: "2.7vh" }} />
                  </Button>
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "4.5%",
                      margin: "0 1vw 0 0.5vw",
                      borderRadius: "7px",
                      height: "inherit",
                      borderColor: "#fff",
                    }}
                    id="sm-product-drawer"
                    // onClick={() => setIsProductsFilter(true)}
                    onClick={() => {
                      setFilterDrawer(true);
                    }}
                  >
                    <img src={FilterIcon} style={{ height: "2.7vh" }} />
                  </Button>
                </div>
                <div style={{ padding: "1.5%" }}>
                  {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
                    <div
                      style={{
                        position: "absolute",
                        bottom: "29vh",
                        left: "56vw",
                      }}
                    >
                      <span style={{ opacity: "0.5" }}>ADVANCE</span>
                    </div>
                  ) : null}
                  <div
                    style={{
                      height: "6vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      textAlign: "center",
                      backgroundColor: "#7A92AC",
                      padding: "1vw 0.5rem",
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                      color: "#fff",
                    }}
                  >
                    <span
                      style={{ fontSize: "0.85rem", cursor: "pointer" }}
                      //   onClick={() => {
                      //     // setIsSectionVisible(true);
                      //     let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
                      //     if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
                      //       setShowDocumentPopup(true);
                      //     }
                      //   }}
                    >
                      Estimate
                      {/* {selectedDocumentType || "Sales Invoice"} <DownOutlined style={{ fontSize: "0.7rem" }} /> */}
                    </span>
                    <span style={{ fontSize: "0.7rem", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      Estimate No: {estimateNo}
                      <img
                        src={NotesAdd}
                        onClick={() => {
                          setNotesPopup(true);
                          if (cart.description && cart.description.trim() !== "") {
                            setNotesValue(cart.description);
                          }
                          setIsInputFocused(true);
                        }}
                        style={{ height: "0.85rem", paddingLeft: "0.7rem", cursor: "pointer", paddingRight: "0.3rem" }}
                      />
                      {/* {posConfig?.enableDeliveryDate === "Y" && (
                                <Popover
                                  content={calendarContent(null)}
                                  trigger="click"
                                  visible={calendarVisible}
                                  onVisibleChange={(visible) => {
                                    setCalendarVisible(visible);
                                  }}
                                >
                                  <CalendarOutlined
                                    style={{
                                      fontSize: "0.85rem",
                                      paddingLeft: "0.7rem",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Popover>
                              )} */}
                    </span>
                  </div>
                  <Table
                    className="sm-cart-table-pos"
                    style={{
                      width: "100%",
                      overflowY: "auto",
                      border: "none",
                      // fontSize: "1vw",
                      borderRadius: "7px",
                      padding: "0px 7px",
                      // border: "1px solid rgba(146, 144, 152, 0.4)",
                      height: "50.5vh",
                      background: themeJSON.productTableBGColor || "#fff",
                    }}
                    pagination={false}
                    dataSource={
                      // Filter the data where weight is greater than 0
                      (parseFloat(localStorage.getItem("cartObj"))?.items ? JSON.parse(localStorage.getItem("cartObj")).items : cart?.items || []).filter(
                        (item) => item.weight !== 0
                      )
                    }
                    sticky
                    id="sm-cart-table"
                    rowKey="lineId"
                    rowClassName={(record) => (selectedProductInCart.lineId === record.lineId ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
                    columns={[
                      {
                        title: "Item Name",
                        dataIndex: "name",
                        key: "name",
                        width: "28%",
                        render: (text, record, index) => {
                          return (
                            <>
                              <div className="offerName" style={{ display: "flex", alignItems: "center" }}>
                                {posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? (
                                  <>
                                    {record.salesRepName ? (
                                      <>
                                        <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                        <span>{record.salesRepName}</span>
                                      </>
                                    ) : (
                                      cart.salesRepName && (
                                        <>
                                          <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                                          <span>{cart.salesRepName}</span>
                                        </>
                                      )
                                    )}
                                  </>
                                ) : null}
                              </div>

                              <div
                                onClick={() => {
                                  if (cart.type !== "Layaway") {
                                    selectProductInCart(record);
                                    selectedRowKeys.length > 0 && selectedProductInCart.productId === record.productId ? setShowPaymentMethods(false) : "";
                                  }
                                }}
                                id="sm-product-name"
                                className="tableRow"
                                style={{
                                  textAlign: "left",
                                  // paddingLeft: record.groupedItems ? "40px" : "0px",
                                  // paddingleft: record.children && record.children.length > 0 ? "40px" : "0px",
                                  marginLeft: 0,
                                }}
                              >
                                {record.name}
                              </div>

                              <div
                                className="offerName"
                                style={
                                  {
                                    // paddingLeft: record.children?.[0]?.groupedItems ? "40px" : "0px",
                                  }
                                }
                              >
                                <p style={{ margin: 0 }}>{record.cardNo ? record.cardNo : record.value}</p>
                                {/* {record?.customText ? <p style={{ margin: 0, padding: 0, color: "#FFA500" }}>{record?.customText}</p> : ""} */}
                                {record.newCustomAttributes &&
                                  record.newCustomAttributes.length > 0 &&
                                  Object.entries(record.newCustomAttributes[0]).map(([key, value]) => {
                                    return (
                                      value && (
                                        <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>
                                          {key} - {value}
                                        </p>
                                      )
                                    );
                                  })}

                                {record.selectedAddons &&
                                  record.selectedAddons.length > 0 &&
                                  record.selectedAddons.map((item) => {
                                    return item?.name && <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>{item.name}</p>;
                                  })}

                                <span
                                  style={{
                                    background: Math.abs(record.discount) > 0 ? "#F8C519" : "",
                                    padding: "0.25vw",
                                    display: record.discountName ? "" : "none",
                                  }}
                                >
                                  {Math.abs(record.discount) > 0 ? record.discountName ? <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> : "" : ""}{" "}
                                  {Math.abs(record.discount) > 0 ? record.discountName || "" : ""}{" "}
                                </span>
                              </div>
                            </>
                          );
                        },
                      },
                      {
                        title: "Qty",
                        dataIndex: "weight",
                        key: "weight",
                        width: "11%",
                        render: (text, record, index) => {
                          const wt = parseFloat(text);
                          if (Number.isInteger(wt)) {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {/* <div style={{ margin: "0 3px", fontWeight: "500", fontSize: "1.1vw" }}>{wt.toFixed(record.isQtyDesimal)}</div> */}
                                <div className="tableRow">{wt.toFixed(record.isQtyDesimal)}</div>
                              </div>
                            );
                          } else {
                            return (
                              <>
                                <div>{parseFloat(text).toFixed(record.isQtyDesimal)}</div>
                                <div className="offerName">
                                  {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
                                </div>
                              </>
                            );
                          }
                        },
                        align: "center",
                      },
                      {
                        title: "Discount",
                        dataIndex: "discount",
                        key: "discount",
                        width: "11%",
                        render: (text, record) => {
                          return (
                            <div>
                              <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
                            </div>
                          );
                        },
                        align: "center",
                      },
                      {
                        title: "Tax",
                        dataIndex: "taxAmount",
                        key: "taxAmount",
                        width: "11%",
                        render: (text, record) => {
                          return (
                            <div>
                              <span className="tableRow">
                                {text?.toFixed(pricePrecision).length < 8 ? parseFloat(text)?.toFixed(pricePrecision) : `${text?.toString().substring(0, 8)}`}
                              </span>
                            </div>
                          );
                        },
                        align: "center",
                      },
                      {
                        title: "Price",
                        dataIndex: "realPrice",
                        key: "realPrice",
                        width: "10%",
                        render: (text, record) => {
                          return (
                            <div>
                              <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
                            </div>
                          );
                        },
                        align: "center",
                      },
                      {
                        title: "Total",
                        dataIndex: "nettotal",
                        key: "nettotal",
                        width: "15%",
                        render: (text, record) => {
                          return (
                            <div style={{ position: "relative" }}>
                              <span className="tableRow" style={{ width: "12%", left: "0" }}>
                                {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                &nbsp;
                                {
                                  // text.toString().length < 9 ?
                                  parseFloat(text).toFixed(pricePrecision)
                                  // :
                                  // `${text.toString().substring(0, 5)}...`
                                }
                                &nbsp;
                                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                              </span>
                            </div>
                          );
                        },
                        align: "center",
                      },
                      {
                        title: "",
                        dataIndex: "",
                        key: "",
                        width: "10%",
                        render: (text, record) => {
                          if (record.groupedItems === true) return null;
                          return (
                            <div style={{ position: "relative", display: "flex", justifyContent: "space-evenly" }}>
                              <img
                                src={DeleteProduct}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  clearSelectedProductInCart();
                                  removeProductModal(record);
                                  setIsInputFocused(false);
                                  setShowInputFields(false);
                                  setCustomMixItems([]);
                                  setGroupQty(1);
                                }}
                                id="sm-product-delete"
                                style={{
                                  height: "2.5vh",
                                  cursor: "pointer",
                                  right: 1,
                                  top: "15%",
                                }}
                                // style={{ height: "18px", width: "18px", cursor: "pointer", right: 1, top: "15%", paddingRight: "3px" }}
                              />
                              <img
                                onClick={(e) => {
                                  e.stopPropagation();
                                  clearSelectedProductInCart();
                                  setNotesPopup(true);
                                  setIsInputFocused(true);
                                  setNotesValue(record.notes);
                                  setSelectedProductForNotes(record);
                                  selectProductInCart(record);
                                  setIsInputFocused(false);
                                }}
                                src={NotesImage}
                                alt=""
                                style={{
                                  height: "14px",
                                  width: "14px",
                                  cursor: "pointer",
                                  paddingleft: "0.8vw",
                                }}
                              />
                              {posConfig?.showLineSalesRep === "Y" && (
                                <img
                                  // src={userIcon}
                                  src={userAddIcon}
                                  style={{ height: "2.3vh", cursor: "pointer", paddingTop: "1px" }}
                                  alt=""
                                  onClick={() => {
                                    setOpenSalesRep({ flag: true, level: "line" });
                                  }}
                                />
                              )}
                            </div>
                          );
                        },
                        align: "center",
                      },
                    ]}
                    {...(hasExpandableRows && {
                      expandable: {
                        expandedRowRender: (record) => (record.children && record.children.length > 0 ? <div></div> : null),
                        rowExpandable: (record) => record.children && record.children.length > 0,
                      },
                    })}
                    onRow={(record) => ({
                      onClick: () => {
                        // if (cart.type !== "Layaway") {
                        qtyInputRef?.current?.focus();
                        if (record.posPriceEdit === "Y") {
                          setShowInputFields(true);
                          setRealPrice(record.weight);
                          setFirstInputValue(true);
                        } else {
                          setShowInputFields(false);
                        }
                        if (record.children && record.children.length > 0) {
                          setSelectedCustomMix(record);
                          setCustomMixItems(record.children);
                          setGroupName(record.name);
                          setGroupQty(record.weight);
                          setExistingGroupItems(true);
                        }
                        setIsInputFocused(false);
                        setOverPayedAmount(0);
                        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
                        selectProductInCart(record);
                        setQtyNumberFlag(0);
                        setShowPaymentMethods(false);
                        setSelectedProductInCart(record);
                        setStockList([]);
                      },
                    })}
                  />
                </div>
                <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
                  <div
                    style={{
                      background: themeJSON.taxAndDiscountSectionBGColor || "#fff",
                      height: "23.5vh",
                      width: "60%",
                      marginRight: "1%",
                      border: "1px solid #fff",
                      borderRadius: "7px",
                      padding: "0.5vh",
                      fontSize: "1vw",
                      position: "relative",
                    }}
                  >
                    {/* {tempSaleTypeData?.length > 0 && (
                              <ArrowsAltOutlined
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  right: "1px",
                                  cursor: "pointer",
                                  fontSize: "1.2vw", // optional: to scale appropriately
                                  zIndex: 1, // ensures it's above content
                                }}
                                onClick={() => {
                                  setExpandTotals(true);
                                }}
                              />
                            )} */}
                    <Row style={{ height: "4.5vh" }}>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "0.8vw",
                          textAlign: "left",
                          fontWeight: "500",
                          color: "#0F0718",
                        }}
                      >
                        <p style={styles.screenStyles.mainScreen.subTotalText}>Subtotal:</p>
                      </Col>
                      {/* <Col span={12} style={{ display: "flex", alignItems: "center", paddingRight: "0.8vw", textAlign: "right", justifyContent: "end", color: "#0F0718" }}> */}
                      <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        &nbsp;
                        <p
                          style={{
                            textAlign: "right",
                            margin: "0",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          {parseFloat(localStorage.getItem("cartObj") ? cart.subTotal : cart.subTotal).toFixed(pricePrecision)}
                        </p>
                        <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                      </Col>
                    </Row>

                    <Row style={{ height: "4.4vh" }}>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "0.8vw",
                          fontWeight: "500",
                          textAlign: "left",
                        }}
                      >
                        <p style={styles.screenStyles.mainScreen.subTotalText}>Discount:</p>
                      </Col>
                      <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        &nbsp;
                        <p
                          style={{
                            textAlign: "right",
                            margin: "0",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          {parseFloat(cart.discount ? cart.discount : 0).toFixed(pricePrecision)}
                        </p>
                        <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                      </Col>
                    </Row>

                    <Row style={{ height: "4.5vh" }}>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "0.8vw",
                          fontWeight: "500",
                          textAlign: "left",
                        }}
                      >
                        <p style={styles.screenStyles.mainScreen.subTotalText}>Tax:</p>
                      </Col>
                      <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        &nbsp;
                        <p
                          style={{
                            textAlign: "right",
                            margin: "0",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          {parseFloat(cart.tax).toFixed(pricePrecision)}
                        </p>
                        <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                      </Col>
                    </Row>
                    <Row style={{ height: "4.5vh" }}>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "0.8vw",
                          fontWeight: "500",
                          textAlign: "left",
                        }}
                      >
                        <p style={styles.screenStyles.mainScreen.subTotalText}>Net Value:</p>
                      </Col>
                      <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                        {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        &nbsp;
                        <p
                          style={{
                            textAlign: "right",
                            margin: "0",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          {parseFloat(localStorage.getItem("cartObj") ? cart.total : cart.total)?.toFixed(pricePrecision)}
                        </p>
                        <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                      </Col>
                    </Row>

                    <Row style={{ height: "4.5vh" }}>
                      <Col
                        span={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "0.8vw",
                          fontWeight: "500",
                          textAlign: "left",
                        }}
                      >
                        <p style={styles.screenStyles.mainScreen.subTotalText}>Total Items / Total Qty:</p>
                      </Col>
                      <Col span={12} style={styles.screenStyles.mainScreen.subTotalCurrency}>
                        <p
                          style={{
                            textAlign: "right",
                            margin: "0",
                            fontWeight: "500",
                            color: "#0F0718",
                          }}
                        >
                          {cart.items.length} / {parseFloat(cart.totalQty).toFixed(2)}
                        </p>
                      </Col>
                    </Row>
                    {/* </Scrollbars> */}
                  </div>
                  <div style={{ height: "23.7vh", width: "40%", fontSize: "1vw" }}>
                    <div
                      id="sm-cart-total"
                      // onClick={handleCartTotalClick}
                      // onClick={verifyStock}
                      onClick={async () => {
                        await CWEstimatePrinter(cart);
                        deleteCart();
                        setEstimateNo((prevEstimateNo) => {
                          const newEstimateNo = prevEstimateNo + 1;
                          localStorage.setItem("estimateNo", newEstimateNo);
                          return newEstimateNo;
                        });
                        if (searchInputRef?.current) {
                          searchInputRef.current.focus();
                        }
                      }}
                      style={{
                        height: "18.2vh",
                        position: "relative",
                        background: themeJSON.totalAmountToPaySectionBGColor || "#2F3856",
                        borderRadius: "7px",
                        cursor: "pointer",
                      }}
                    >
                      <p
                        style={{
                          padding: "0.7vw 0 0 1vw",
                          color: "#fff",
                          fontSize: "1em",
                          fontWeight: "500",
                          height: "4.5vh",
                        }}
                      >
                        Total Amount To Pay
                      </p>
                      {cart.total !== undefined ? (
                        <p
                          style={{
                            textAlign: "center",
                            color: "#fff",
                            fontSize: "2.5em",
                            fontWeight: "500",
                            height: "14.4vh",
                            width: "100%",
                          }}
                        >
                          {" "}
                          {parseFloat(localStorage.getItem("cartObj") ? cart.total : cart.total)?.toFixed(pricePrecision)}
                        </p>
                      ) : (
                        <p
                          style={{
                            textAlign: "center",
                            color: "#fff",
                            fontSize: "2.5em",
                            fontWeight: "500",
                            height: "14.4vh",
                            width: "100%",
                          }}
                        >
                          {" "}
                          0.00
                        </p>
                      )}
                    </div>
                    <Row gutter={[8, 0]} style={{ marginTop: "0.8vh" }}>
                      {/* <Col span={12} onClick={openDisplayParkedBillModal}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "500",
                        textAlign: "left",
                        border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                        height: "4.8vh",
                        borderRadius: "5px",
                        cursor: "pointer",
                        backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                      }}
                    >
                      <img src={Hold} style={{ height: "2.5vh" }} />
                      <span
                        style={{
                          margin: "0",
                          textAlign: "center",
                          color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                          paddingLeft: "0.5vw",
                          fontSize: "1em",
                          fontWeight: 500,
                        }}
                      >
                        Hold
                      </span>
                    </div>
                  </Col> */}
                      <Col span={24}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",

                            fontWeight: "500",
                            justifyContent: "center",
                            border: `1px solid ${themeJSON.holdAndCancelButtonBGColor || "rgba(146, 144, 152, 0.5)"}`,
                            height: "4.8vh",
                            borderRadius: "5px",
                            cursor: "pointer",
                            backgroundColor: themeJSON.holdAndCancelButtonBGColor || "#fff",
                          }}
                          id="sm-delete-cart"
                          //   onClick={deleteProductModal}
                          onClick={() => {
                            deleteCart();
                            if (searchInputRef?.current) {
                              searchInputRef.current.focus();
                            }
                          }}
                        >
                          <img src={Cancel} style={{ height: "2.5vh" }} />
                          <span
                            style={{
                              textAlign: "center",
                              margin: "0",
                              color: themeJSON.holdAndCancelButtonTextColor || "#2F3856",
                              paddingLeft: "0.5vw",
                              fontSize: "1em",
                              fontWeight: 500,
                            }}
                          >
                            Cancel
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "35.6%",
                  padding: "0% 0% 0 0.4%",
                  borderRadius: "10px",
                  paddingBottom: "0",
                  height: "89vh",
                  marginRight: "1%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ||
                  tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
                    <Input
                      className="productSearch-sm"
                      id="sm-customer-search"
                      style={{
                        borderRadius: "0.5vw",
                        height: "4.9vh",
                        borderColor: "#fff",
                      }}
                      placeholder="Enter customer number/name"
                      prefix={<img src={CustomerSearch} alt="" style={{ height: "2.7vh" }} />}
                      onClick={() => {
                        if (cart.isReturn !== true) {
                          setDisplayCustomerSearch(true);
                          setCloseCustomerFlag(true);
                        }
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        padding: "0.7vh 1.3vh",
                        border: "none",
                        background: "#fff",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        height: "5vh",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        <img src={CustomerIcon} style={{ height: "3.5vh" }}></img>{" "}
                        <span style={{ fontSize: "1vw" }}>
                          {cart?.customer?.name} - {cart?.customer?.b2cCustomerSegment?.name}
                        </span>
                      </span>
                      <span>
                        <img
                          src={View}
                          style={{
                            height: "3vh",
                            paddingBottom: "0.1em",
                            cursor: "pointer",
                          }}
                          id="sm-customer-view"
                          onClick={() => {
                            if (cart.isReturn !== true) showEditOldCustomerFields(cart?.customer);
                          }}
                        />{" "}
                        &#124;{" "}
                        <EditOutlined
                          style={{ cursor: "pointer" }}
                          id="sm-customer-edit"
                          onClick={() => {
                            if (cart.isReturn !== true) {
                              showEditOldCustomerFields(cart?.customer);
                              setEditFlag(true);
                            }
                          }}
                        />{" "}
                        &#124;{" "}
                        <CloseOutlined
                          style={{ fontSize: "2vh" }}
                          onClick={() => {
                            if (cart.isReturn !== true) {
                              removeCutomer();
                            }
                          }}
                        ></CloseOutlined>
                      </span>
                    </div>
                  )}
                  <img
                    src={AddUser}
                    style={{
                      height: "1.6vw",
                      paddingLeft: "1vw",
                      cursor: "pointer",
                      display: cart?.customer?.cwrCustomerId === customerId ? "" : "none",
                    }}
                    onClick={() => {
                      if (cart.isReturn !== true) showAddNewCustomerFields(cart.customer);
                    }}
                  />
                </div>
                <div style={{ display: "flex", fontSize: "1vw" }}>
                  <div
                    style={{
                      width: "18%",
                      paddingTop: "3%",
                      display: "flex",
                      flexDirection: "column-reverse",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.01rem",
                        display: tillAccessData?.productSync === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-product-sync"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          let parkedBills = JSON.parse(localStorage.getItem("parkedList"));
                          if (cart.items.length > 0) {
                            openDisplayParkedBillModal();
                          } else if (parkedBills?.length > 0) {
                            message.error(`${messages.errors.sync.clear_parked_bills}`);
                          } else {
                            if (isOnline) {
                              handleKeyvalue("4");
                            } else {
                              errorMessage(`${messages.errors.sync.sync_failed}`, `${messages.errors.sync.network_error}`);
                            }
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            fontSize: "1vw",
                          }}
                        >
                          <img src={SyncIcon} style={{ height: "2.5vh" }} color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Product Sync</span>
                        </div>
                      </button>
                    </div>
                    <div style={{ width: "100%", display: "none" }}>
                      <button
                        className="cartMenuItems"
                        id="sm-pos"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        // onClick={() => {
                        //   handleKeyvalue("0");
                        //   setTableValue("POS");
                        // }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <POSIcon color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Point of Sale
                          </span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={information} style={{ height: "2.7vh" }} color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Information
                          </span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: "none",
                        fontSize: "1vw",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-return"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          if (cart.items.length > 0) {
                            openDisplayParkedBillModal();
                          } else {
                            handleKeyvalue("3");
                            setReturnFlag(true);
                            setIsPurchaseReturn(true);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={ReturnIcon} style={{ height: "2.5vh" }} color={"#fff"} />
                          <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
                            Return
                          </span>
                        </div>
                      </button>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: posConfig?.showBags === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-discount"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          setAddToBagFlag(true);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={giftVoucher} style={{ height: "2.6vh" }} color={"#fff"} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Bag</span>
                        </div>
                      </button>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        marginBottom: "0.37rem",
                        display: posConfig?.showOrderSalesRep === "Y" ? "block" : "none",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        id="sm-parked-bill"
                        style={{
                          backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                          border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                          borderRadius: "7px",
                          height: "9.5vh",
                        }}
                        onClick={() => {
                          setOpenSalesRep({ flag: true, level: "order" });
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={user_add} style={{ color: "#fff", height: "2.5vh" }} />
                          <span style={styles.screenStyles.mainScreen.posIcon}>Sales Representative</span>
                        </div>
                      </button>
                    </div>
                    {/* {tempSaleTypeData?.length > 0 && (
                              <div
                                style={{
                                  width: "100%",
                                  marginBottom: "0.37rem",
                                }}
                              >
                                <button
                                  className="cartMenuItems"
                                  id="sm-parked-bill"
                                  style={{
                                    backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                                    border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                                    borderRadius: "7px",
                                    height: "9.5vh",
                                  }}
                                  onClick={() => {
                                    setAdditionalCharges(true);
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <AdditionalChargesIcon color={"#fff"} />
                                    <span style={styles.screenStyles.mainScreen.posIcon}>Additional Charges</span>
                                  </div>
                                </button>
                              </div>
                            )} */}

                    {/* <div
                  style={{
                    width: "100%",
                    marginBottom: "0.37rem",
                    display: tillAccessData?.parkedBills === "Y" ? "block" : "none",
                  }}
                >
                  <button
                    className="cartMenuItems"
                    id="sm-parked-bill"
                    style={{
                      backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
                      border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
                      borderRadius: "7px",
                      height: "9.5vh",
                    }}
                    onClick={() => {
                      handleKeyvalue("parked-bill");
                      setIsparkedBill(true);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <ParkedBillIcon color={"#fff"} />
                      <span style={styles.screenStyles.mainScreen.posIcon}>Parked Bills</span>
                    </div>
                  </button>
                </div> */}
                  </div>
                  <div
                    style={{
                      width: "81.5%",
                      paddingTop: "3%",
                      display: showPaymentMethods && "none",
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        height: "41vh",
                        width: "95%",
                        margin: "0% 1% 2.7% 3.5%",
                        border: "1px solid #fff",
                        borderRadius: "7px",
                        visibility: Object.keys(selectedProductInCart).length > 0 ? "visible" : "hidden",
                      }}
                    >
                      {stockList.length > 0 ? (
                        <div>
                          <img
                            src={Back}
                            onClick={() => setStockList([])}
                            id="sm-parked-bill-back"
                            style={{
                              height: "2vw",
                              paddingBottom: "0.5em",
                              cursor: "pointer",
                              marginLeft: "10px",
                              marginTop: "0.7em",
                            }}
                          />
                          <Table
                            style={{
                              width: "100%",
                              overflowY: "auto",
                              borderRadius: "10px",
                              padding: "0",
                              height: "36vh",
                              background: "#fff",
                              maxHeight: "34vh",
                              display: "block",
                            }}
                            size="small"
                            locale={{ emptyText: "No data" }}
                            pagination={false}
                            dataSource={[...stockList]}
                            className="sm-stock-table"
                            columns={[
                              {
                                title: "Store",
                                dataIndex: "store",
                                key: "store",
                                render: (text, record) => <div>{record?.warehouse?.name || ""}</div>,
                              },
                              {
                                title: "In Stock",
                                dataIndex: "stock",
                                key: "stock",
                                render: (text, record) => <div>{record?.warehouse?.storageBin?.totalQty || 0}</div>,
                                align: "right",
                              },
                            ]}
                          />
                        </div>
                      ) : selectedProductInCart?.productSegment === "CB" && selectedProductInCart?.childItems?.length > 0 ? (
                        <div style={{ position: "relative", padding: "0.5rem", borderRadius: "6px", backgroundColor: "#fff", height: "100%" }}>
                          {/* Title at the top */}
                          {/* Header Row */}
                          <Row
                            style={{ padding: "0.1rem 0.75rem", fontSize: "0.75rem", fontWeight: 600, color: "#2F3856", borderBottom: "1px solid #e8e8e8", marginBottom: "0.5rem" }}
                          >
                            <Col span={8}>Name</Col>
                            <Col span={6} style={{ textAlign: "right" }}>
                              Unit Price
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                              Qty
                            </Col>
                            <Col span={6} style={{ textAlign: "right" }}>
                              Total Price
                            </Col>
                          </Row>

                          {/* Item Details */}
                          <Scrollbars style={{ height: "28vh" }}>
                            {selectedProductInCart.childItems.map((item) => {
                              const unitPrice = parseFloat(item.sunitprice) || 0;
                              const quantity = parseFloat(item.weight * selectedProductInCart.weight) || 0;
                              const totalPrice = unitPrice * quantity;
                              const stdPrecision = item?.uomData[0]?.stdPrecision || 0;

                              return (
                                <Row
                                  key={item.id || item.name}
                                  style={{
                                    padding: "0 0.75rem",
                                    width: "100%",
                                    marginBottom: "0.4rem",
                                    height: "auto",
                                    alignItems: "center",
                                  }}
                                >
                                  <Col span={8}>
                                    <p
                                      title={item.name}
                                      style={{
                                        margin: 0,
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        color: "#333",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                      }}
                                    >
                                      {item.name}
                                    </p>
                                  </Col>
                                  <Col span={6} style={{ textAlign: "right" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "0.6rem",
                                        color: "#2F3856",
                                      }}
                                    >
                                      {unitPrice.toLocaleString("en-IN")}
                                    </p>
                                  </Col>
                                  <Col span={4} style={{ textAlign: "right" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "0.6rem",
                                        color: "#2F3856",
                                      }}
                                    >
                                      {quantity}
                                    </p>
                                  </Col>
                                  <Col span={6} style={{ textAlign: "right" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "0.6rem",
                                        color: "#2F3856",
                                      }}
                                    >
                                      {totalPrice.toLocaleString("en-IN")}
                                    </p>
                                  </Col>
                                </Row>
                              );
                            })}
                          </Scrollbars>

                          {/* Modify button at bottom right */}
                          <Button
                            style={{
                              position: "absolute",
                              bottom: "0.5rem",
                              right: "0.5rem",
                              backgroundColor: "#2F3856",
                              color: "#fff",
                              width: "7vw",
                              height: "4.5vh",
                              borderRadius: "3px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "none",
                              fontSize: "0.75rem",
                            }}
                            onClick={modifyProductList}
                          >
                            Modify
                          </Button>
                        </div>
                      ) : (
                        <Row gutter={[16]} style={{ paddingTop: "3vh" }}>
                          <Col span={7} style={{ height: "24vh" }}>
                            <img
                              style={{
                                width: "100%",
                                height: "27vh",
                                objectFit: "contain",
                                borderRadius: "5px",
                                paddingTop: "1vh",
                                alignSelf: "center",
                                padding: "1vh 0 1vh 0.8vw",
                              }}
                              src={selectedProductInCart.imageurl || DefaultProductImage}
                              alt=""
                            />
                          </Col>
                          <Col span={17} style={{ height: "24vh", position: "relative" }}>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              {selectedProductInCart["name"]?.toString().substring(0, 27)}...
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              {selectedProductInCart["productBrandName"]}
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "2.5em",
                                fontFamily: "Inter",
                              }}
                            >
                              {currenciesList[0].symbolRightSide === "N"
                                ? `${currenciesList[0].currSymbol}`
                                : currenciesList[0].symbolRightSide === "Y"
                                  ? `${currenciesList[0].currSymbol}`
                                  : ""}{" "}
                              {Number(selectedProductInCart["realPrice"]).toFixed(pricePrecision)}
                            </p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "500",
                                color: "#0F0718",
                                fontSize: "1em",
                                fontFamily: "Inter",
                              }}
                            >
                              Quantity : {selectedProductInCart["weight"]}
                            </p>
                            {stockList.length > 0 ? (
                              <CloseCircleOutlined
                                onClick={() => setStockList([])}
                                style={{
                                  position: "absolute",
                                  top: "25vh",
                                  left: "18vw",
                                  cursor: "pointer",
                                }}
                              />
                            ) : null}
                            <button
                              onClick={handleViewStockClick}
                              style={{
                                backgroundColor: "#046307C2",
                                border: "1px solid #fff",
                                borderRadius: "7px",
                                height: "5vh",
                                width: "7vw",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                  color: "#fff",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  fontFamily: "Inter",
                                }}
                              >
                                View Stock
                              </div>
                            </button>
                            {stockList.map((record) => (
                              <p
                                key={record.id || record.name}
                                style={{
                                  margin: 0,
                                  fontWeight: "500",
                                  fontSize: "1em",
                                  color: "#0F0718",
                                  fontFamily: "Inter",
                                }}
                              >
                                {record?.name || ""} stock : {record?.warehouse?.storageBin?.totalQty || 0}
                              </p>
                            ))}
                          </Col>
                        </Row>
                      )}
                      {stockList.length < 0 ? (
                        <div style={{ padding: "1vh 1vw" }}>
                          <p
                            style={{
                              margin: 0,
                              textAlign: "left",
                              color: "#0F0718",
                              fontWeight: "500",
                            }}
                          >
                            Description:
                          </p>
                          <p
                            style={{
                              margin: 0,
                              textAlign: "left",
                              color: "#2F3856",
                              fontSize: "1em",
                              fontWeight: "500",
                            }}
                          >
                            {selectedProductInCart["description"]?.substring(0, 180)?.concat("....")}
                          </p>
                        </div>
                      ) : null}
                    </div>
                    <></>
                    {!showInputFields ? (
                      <div>
                        <Row style={{ margin: " 2% 0 0 0 " }}>
                          <Input
                            className="productSearch sm-payment-search totalQtyInput"
                            style={{
                              borderRadius: "0.5vw",
                              height: "8.3vh",
                              margin: "0 1% 2.7% 3.5%",
                              borderRadius: "5px",
                              textAlign: "right",
                              fontWeight: "500",
                              fontSize: "2.5em",
                              borderColor: "#fff",
                              color: "#2F3856",
                              fontFamily: "Inter",
                            }}
                            // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                            value={selectedProductInCart.weight}
                            id="sm-amount-input"
                            ref={qtyInputRef}
                            // type="number"
                            onChange={(e) => {
                              if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0) {
                                onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
                              }
                            }}
                            readOnly={cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 ? false : true}
                            placeholder="Enter Quantity"
                            onFocus={() => {
                              setIsInputFocused(true);
                            }}
                            onBlur={() => {
                              setIsInputFocused(false);
                            }}
                            // ref={quantityInputRef}
                            onPressEnter={enterTotalQty}
                          />
                        </Row>
                        <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                          <Col span={6}>
                            <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                              1
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                              2
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                              3
                            </button>
                          </Col>
                          <Col span={6}>
                            <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
                              <img src={CancelArrow} alt="back space" width={25} height={15} />
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                              4
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                              5
                            </button>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                              6
                            </button>
                          </Col>
                          <Col span={6}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <button
                                id="sm-amount-addQuantity"
                                onClick={() => {
                                  if (Object.keys(selectedProductInCart).length > 0) {
                                    decreaseProductQty(selectedProductInCart);
                                  }
                                }}
                                className="amt-dial-btn-market-qty"
                              >
                                -
                              </button>
                              <button
                                id="sm-amount-addQuantity"
                                onClick={async () => {
                                  if (Object.keys(selectedProductInCart).length > 0) {
                                    increaseProductQty(selectedProductInCart);
                                    // if(selectedProductInCart?.bundleId !== undefined){
                                    //   const productItem = await getProductData(selectedProductInCart.productId);
                                    //   productItem.weight = 1;
                                    //   productItem.isReturn = false;
                                    //   increaseProductQty(productItem);
                                    // }else{
                                    //   increaseProductQty(selectedProductInCart);
                                    // }
                                  }
                                }}
                                className="amt-dial-btn-market-qty"
                              >
                                +
                              </button>
                            </div>
                          </Col>
                          <Col span={18}>
                            <Row gutter={[8, 6]}>
                              <Col span={8}>
                                <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                                  7
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                                  8
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                                  9
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                                  0
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                                  .
                                </button>
                              </Col>
                              <Col span={8}>
                                <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                                  Clear
                                </button>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={6}>
                            <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                              Enter
                            </button>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <div>
                        <Tabs
                          defaultActiveKey="1"
                          className="custom-tabs"
                          // style={{ padding: "0 1% 0 3.5%" }}
                          style={{
                            // position: "absolute",
                            // top: "52%",
                            // left: "71.2%",
                            marginTop: "-11%",
                            marginLeft: "4%",
                            width: "94%",
                            height: "auto",
                            // background: "rgba(255, 255, 255, 0.95)",
                            zIndex: 1000,
                            transition: "top 0.5s ease",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                          }}
                        >
                          <TabPane tab="Qty" key="1" className="custom-tabpane" style={{ marginRight: "1vw" }}>
                            <Row style={{ margin: "0 0 0 0 " }}>
                              <Input
                                className="productSearch sm-payment-search totalQtyInput"
                                value={selectedProductInCart.weight}
                                style={{
                                  borderRadius: "0.5vw",
                                  height: "6.5vh",
                                  margin: "0% 1% 1% 0%",
                                  borderRadius: "5px",
                                  textAlign: "right",
                                  fontWeight: "500",
                                  fontSize: "2.5em",
                                  color: "#2F3856",
                                  borderColor: "#fff",
                                }}
                                id="sm-amount-input"
                                placeholder="Enter Quantity"
                              />
                            </Row>
                            <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                              <Col span={6}>
                                <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleTotalQty("1")}>
                                  1
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleTotalQty("2")}>
                                  2
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleTotalQty("3")}>
                                  3
                                </button>
                              </Col>
                              <Col span={6}>
                                <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
                                  <img src={CancelArrow} alt="back space" width={25} height={15} />
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleTotalQty("4")}>
                                  4
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleTotalQty("5")}>
                                  5
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleTotalQty("6")}>
                                  6
                                </button>
                              </Col>
                              <Col span={6}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <button
                                    id="sm-amount-addQuantity"
                                    onClick={() => {
                                      if (Object.keys(selectedProductInCart).length > 0) {
                                        decreaseProductQty(selectedProductInCart);
                                      }
                                    }}
                                    className="amt-dial-btn-market-qty"
                                  >
                                    -
                                  </button>
                                  <button
                                    id="sm-amount-addQuantity"
                                    onClick={async () => {
                                      if (Object.keys(selectedProductInCart).length > 0) {
                                        increaseProductQty(selectedProductInCart);
                                        // if(selectedProductInCart?.bundleId !== undefined){
                                        //   const productItem = await getProductData(selectedProductInCart.productId);
                                        //   productItem.weight = 1;
                                        //   productItem.isReturn = false;
                                        //   increaseProductQty(productItem);
                                        // }else{
                                        //   increaseProductQty(selectedProductInCart);
                                        // }
                                      }
                                    }}
                                    className="amt-dial-btn-market-qty"
                                  >
                                    +
                                  </button>
                                </div>
                              </Col>
                              <Col span={18}>
                                <Row gutter={[8, 6]}>
                                  <Col span={8}>
                                    <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleTotalQty("7")}>
                                      7
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleTotalQty("8")}>
                                      8
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("9")}>
                                      9
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleTotalQty("0")}>
                                      0
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleTotalQty(".")}>
                                      .
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleTotalQty("clear")}>
                                      Clear
                                    </button>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterTotalQty}>
                                  Enter
                                </button>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tab="Price" key="2" className="custom-tabpane" style={{ marginRight: "1vw" }}>
                            <Row style={{ margin: "0 0 0 0 " }}>
                              <Input
                                className="productSearch sm-payment-search totalQtyInput"
                                // value={selectedProductInCart.realPrice}
                                value={realPrice}
                                onChange={(e) => {
                                  setRealPrice(e.target.value);
                                }}
                                style={{
                                  borderRadius: "0.5vw",
                                  height: "6.5vh",
                                  margin: "0% 1% 1% 0%",
                                  borderRadius: "5px",
                                  textAlign: "right",
                                  fontWeight: "500",
                                  fontSize: "2.5em",
                                  color: "#2F3856",
                                  borderColor: "#fff",
                                }}
                                id="sm-amount-input"
                                placeholder="Enter Price"
                              />
                            </Row>
                            <Row style={{ padding: "0 1% 0 0", marginTop: "1vh" }} gutter={[8, 6]}>
                              <Col span={6}>
                                <button id="sm-amount-button1" className="amt-dial-btn-market" onClick={() => handleRealPrice("1")}>
                                  1
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button2" className="amt-dial-btn-market" onClick={() => handleRealPrice("2")}>
                                  2
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button3" className="amt-dial-btn-market" onClick={() => handleRealPrice("3")}>
                                  3
                                </button>
                              </Col>
                              <Col span={6}>
                                <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleRealPrice("x")}>
                                  <img src={CancelArrow} alt="back space" style={{ width: "20px", height: "15px" }} />
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button4" className="amt-dial-btn-market" onClick={() => handleRealPrice("4")}>
                                  4
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button5" className="amt-dial-btn-market" onClick={() => handleRealPrice("5")}>
                                  5
                                </button>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-button6" className="amt-dial-btn-market" onClick={() => handleRealPrice("6")}>
                                  6
                                </button>
                              </Col>
                              <Col span={6}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <button
                                    id="sm-amount-addQuantity"
                                    className="amt-dial-btn-market-qty"
                                    onClick={() => {
                                      setRealPrice((prev) => {
                                        const numeric = parseFloat(prev) || 0;
                                        const newValue = Math.max(numeric - 1, 1);
                                        return newValue.toString();
                                      });
                                    }}
                                  >
                                    -
                                  </button>
                                  <button
                                    id="sm-amount-addQuantity"
                                    className="amt-dial-btn-market-qty"
                                    onClick={() => {
                                      setRealPrice((prev) => {
                                        const numeric = parseFloat(prev) || 0;
                                        return (numeric + 1).toString();
                                      });
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              </Col>
                              <Col span={18}>
                                <Row gutter={[8, 6]}>
                                  <Col span={8}>
                                    <button id="sm-amount-button7" className="amt-dial-btn-market" onClick={() => handleRealPrice("7")}>
                                      7
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button8" className="amt-dial-btn-market" onClick={() => handleRealPrice("8")}>
                                      8
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("9")}>
                                      9
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button0" className="amt-dial-btn-market" onClick={() => handleRealPrice("0")}>
                                      0
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button00" className="amt-dial-btn-market" onClick={() => handleRealPrice("00")}>
                                      00
                                    </button>
                                  </Col>
                                  <Col span={8}>
                                    <button id="sm-amount-button." className="amt-dial-btn-market" onClick={() => handleRealPrice(".")}>
                                      .
                                    </button>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={6}>
                                <button id="sm-amount-buttonEnter" className="amt-dial-btn-market2" onClick={enterRealPrice}>
                                  Enter
                                </button>
                              </Col>
                            </Row>
                          </TabPane>
                          {/* <TabPane
                                    className="custom-tabpane"
                                    tab={
                                      <>
                                        <CloseOutlined
                                          style={{
                                            marginLeft: "0.5rem",
                                            cursor: "pointer",
                                            fontSize: "17px",
                                            color: "#2F3856",
                                          }}
                                        />
                                      </>
                                    }
                                    key="3"
                                  ></TabPane> */}
                        </Tabs>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      width: "81.5%",
                      paddingTop: "3%",
                      display: !showPaymentMethods && "none",
                    }}
                  >
                    <Row style={{ padding: "0 1% 0 3.5%", height: "18.5vh" }} gutter={5}>
                      {_.sortBy(showPayments, "sequenceNo").map((pm, ind) => {
                        if (
                          (posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty") ||
                          (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty") ||
                          (!cart.customer.iscredit && pm.name === "Credit") ||
                          pm.name.toLowerCase() === "cafe tips"
                        ) {
                          return null;
                        }
                        return (
                          <Col span={8} key={pm.finPaymentmethodId}>
                            <button
                              onClick={async () => {
                                if (cart.items.length > 0 && pm.name !== "Complete Order") {
                                  setNumb(0);
                                  let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
                                    orderStartTime: "",
                                    orderEndTime: "",
                                    paymentStartTime: "",
                                  };
                                  if (orderTimeDetails.paymentStartTime === "") {
                                    orderTimeDetails = {
                                      ...orderTimeDetails,
                                      paymentStartTime: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                                    };
                                    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
                                  }
                                  if (pm.name.toLowerCase() === "card" && !pm.integratedPayment && posConfig?.enablePaymentData === "Y") {
                                    setIsCardPaymentFlag(true);
                                  }
                                  const currenciesList = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

                                  // let originalAmount = Math.abs(cart.total) - cart.paid ?? 0;
                                  let originalAmount = Math.abs(cart.total) - (cart.paid ?? 0);

                                  // Get the smallest denomination (assuming sorted list)
                                  const smallestDenomination = currenciesList.length > 0 ? currenciesList[0].value : 1;

                                  // Round the amount to the nearest multiple of the smallest denomination
                                  let roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;

                                  // Calculate overpayment
                                  let overpayment = (roundedAmount - originalAmount).toFixed(precision);
                                  setOverPayedAmount(pm.roundOffForPos === "Y" ? overpayment : 0);
                                  setAmount(pm.roundOffForPos === "Y" ? roundedAmount.toFixed(precision) : parseFloat(originalAmount).toFixed(precision));
                                  setSelectedPaymentMethod(pm);
                                  paymentModalInputRef?.current?.focus();
                                  setTimeout(() => {
                                    paymentModalInputRef?.current?.select();
                                  }, 50);
                                } else if (pm.name === "Complete Order" && cart.paid >= cart.total) {
                                  processOrder();
                                }
                                setShowInputFields(false);
                              }}
                              id={`sm-payment-${pm.name.toLowerCase()}`}
                              ref={ind === 0 ? paymentCardRef : null}
                              style={{
                                backgroundColor: pm.name === "Complete Order" ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#046307C2",
                                border: `1px solid ${themeJSON.paymentMethodsBGColor || "#fff"}`,
                                borderRadius: "7px",
                                height: "8.6vh",
                                width: "100%",
                                cursor: "pointer",
                              }}
                              tabIndex={0}
                              onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                  position: "relative",
                                  fontSize: "1vw",
                                }}
                              >
                                {pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? (
                                  <img
                                    src={ticSelect}
                                    style={{
                                      top: "-2vh",
                                      right: "0",
                                      height: "2.1vh",
                                      position: "absolute",
                                    }}
                                  />
                                ) : null}
                                <span className="payment" style={{ color: "#fff", fontSize: "1em" }}>
                                  {pm.name.toLowerCase() === "cash" ? (
                                    <>
                                      {currenciesList[0] ? currenciesList[0].currSymbol : ""}
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "card" ? (
                                    <>
                                      <img src={cardType} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "upi" ? (
                                    <>
                                      <img src={UPI} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "credit" ? (
                                    <>
                                      <img src={Credit} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "loyalty" ? (
                                    <>
                                      <img
                                        src={Loyality}
                                        style={{
                                          height: "2.5vh",
                                          left: "0.5em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "gift card" ? (
                                    <>
                                      <img
                                        src={Gift}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "voucher" ? (
                                    <>
                                      <img
                                        src={giftVoucher}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                        }}
                                        color={"#fff"}
                                      />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : pm.name.toLowerCase() === "credit note" ? (
                                    <>
                                      <img src={creditNote} style={{ height: "2.5vh" }} color={"#fff"} />
                                      &nbsp;{pm.name}
                                    </>
                                  ) : (
                                    <>{pm.name}</>
                                  )}
                                </span>
                              </div>
                            </button>
                          </Col>
                        );
                      })}
                      {cart.layAway === "Y" && posConfig?.advanceLayaway === "Y" ? (
                        <Col
                          span={8}
                          onClick={() => {
                            if (posConfig?.requirePaymentForAdvance === "Y" && cart.paid <= 0) {
                              message.warning(`${messages.warnings.payment.payment_required}`);
                              return;
                            }
                            if (cart.paid <= cart.total) {
                              cart.statusType = "layAway";
                              localStorage.setItem("cartObj", JSON.stringify(cart));
                              const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                              const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);

                              const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                              const isValidCashAmount = parseFloat(amount) % 0.25 === 0;

                              if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                if (result !== 0 && isCashPayment) {
                                  message.warning(`${t("cash_payment_error")}`);
                                } else {
                                  processOrder("layaway");
                                }
                              } else {
                                processOrder("layaway");
                              }
                            }
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#2F3856",
                              border: "1px solid #fff",
                              borderRadius: "7px",
                              height: "8.6vh",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                                color: "#fff",
                              }}
                            >
                              Create Advance
                            </div>
                          </button>
                        </Col>
                      ) : null}

                      {showPayments.length < filteredPaymentMethods.length && (
                        <Col span={8}>
                          <button
                            onClick={isShowingAll ? showPreviousItems : showMoreItems}
                            style={{
                              backgroundColor: "#046307C2",
                              border: "1px solid #fff",
                              borderRadius: "7px",
                              height: "8.6vh",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                              }}
                            >
                              <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                              <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                                ...
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}
                    </Row>
                    <div
                      style={{
                        background: "#fff",
                        height: "23vh",
                        width: "95%",
                        margin: "0.75% 1% 2.7% 3.5%",
                        border: "1px solid #fff",
                        borderRadius: "7px",
                      }}
                    >
                      <Row
                        style={{
                          height: "3vh",
                          marginTop: "3%",
                          fontSize: "1vw",
                        }}
                      >
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Amount Tendered</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {parseFloat(cart.total).toFixed(pricePrecision)}
                          </p>
                        </Col>
                      </Row>

                      <Row style={{ height: "3vh", fontSize: "1vw" }}>
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Change</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {(cart.paid ?? 0) + parseFloat(amount) - Math.abs(cart.total) > 0
                              ? ((cart.paid ?? 0) + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                              : cart?.change <= 0
                                ? "0.00"
                                : cart?.change}
                          </p>
                        </Col>
                      </Row>

                      <Row style={{ height: "3vh", fontSize: "1vw" }}>
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Overpayment</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {Math.abs(overPayedAmount).toFixed(pricePrecision)}
                          </p>
                        </Col>
                      </Row>

                      <Row style={{ height: "3vh", fontSize: "1vw" }}>
                        <Col span={12} style={styles.screenStyles.mainScreen.card}>
                          <p style={{ margin: "0" }}>Remaining Due</p>
                        </Col>
                        <Col
                          span={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "1vw",
                            textAlign: "right",
                            justifyContent: "end",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "right",
                              margin: "0",
                              fontWeight: "500",
                              color: "#0F0718",
                              fontSize: "1em",
                            }}
                          >
                            {parseFloat(Math.abs(cart.total)) >= parseFloat(cart.paid) ? parseFloat(Math.abs(cart.total) - cart.paid).toFixed(pricePrecision) : 0}
                          </p>
                        </Col>
                      </Row>
                      <hr style={{ margin: "1vh 1vw" }} />
                      <Scrollbars style={{ height: "6.3vh" }}>
                        {cart?.advancePayment > 0 &&
                          cart.layAway === "Y" &&
                          cart?.paymentData?.map((item) => {
                            return (
                              <Row style={{ fontSize: "1vw" }}>
                                <Col
                                  span={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingLeft: "0.8vw",
                                    fontWeight: "450",
                                    textAlign: "left",
                                  }}
                                >
                                  <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" ? `${item.name} - ${item.authorizationCode}` : item.name}</p>
                                </Col>
                                <Col
                                  span={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingRight: "1vw",
                                    textAlign: "right",
                                    justifyContent: "end",
                                  }}
                                >
                                  {/* {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                                  &nbsp; */}
                                  <p
                                    style={{
                                      textAlign: "right",
                                      margin: "0",
                                      fontWeight: "500",
                                      paddingRight: "1.2vw",
                                    }}
                                  >
                                    {" "}
                                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                    &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                  </p>
                                </Col>
                              </Row>
                            );
                          })}
                        {cart.payments.map((item) => {
                          return (
                            <Row style={{ fontSize: "1vw" }}>
                              <Col
                                span={12}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: "0.8vw",
                                  fontWeight: "450",
                                  textAlign: "left",
                                }}
                              >
                                <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" ? `${item.name} - ${item.authorization}` : item.name}</p>
                              </Col>
                              <Col
                                span={12}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  paddingRight: "1vw",
                                  textAlign: "right",
                                  justifyContent: "end",
                                }}
                              >
                                {/* {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                                  &nbsp; */}
                                <p
                                  style={{
                                    textAlign: "right",
                                    margin: "0",
                                    fontWeight: "500",
                                    paddingRight: "1.2vw",
                                  }}
                                >
                                  {" "}
                                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                  &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                </p>
                                <img
                                  src={DeleteProduct}
                                  onClick={() => handleDeletePayment(item)}
                                  style={{
                                    height: "15px",
                                    width: "15px",
                                    cursor: "pointer",
                                    marginLeft: "1vw",
                                    position: "absolute",
                                    right: 5,
                                    top: "15%",
                                  }}
                                />
                                {/* <span style={{ marginLeft: "2px" }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span> */}
                              </Col>
                            </Row>
                          );
                        })}
                      </Scrollbars>
                    </div>
                    <Row style={{ margin: "0 0 0 0 " }}>
                      <Input
                        className="productSearch sm-payment-search totalInput"
                        style={{
                          borderRadius: "0.5vw",
                          height: "7.3vh",
                          margin: "0 1% 2.7% 3.5%",
                          borderRadius: "5px",
                          textAlign: "right",
                          fontWeight: "500",
                          fontSize: "2.5em",
                          borderColor: "#fff",
                          color: "#2F3856",
                        }}
                        // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                        value={amount}
                        // type="number"
                        id="sm-total-amount-input"
                        onChange={onChangeAmount}
                        placeholder="Enter Amount"
                        ref={paymentModalInputRef}
                        onFocus={() => {
                          setIsInputFocused(true);
                        }}
                        onBlur={() => {
                          setIsInputFocused(false);
                        }}
                        readOnly={cart.items.length > 0 ? false : true}
                        disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
                        onPressEnter={async () => {
                          if (
                            selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                            parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                            posConfig?.showPaymentSummary === "Y" &&
                            !(await showConfirm())
                          ) {
                            return;
                          }
                          const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                          const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                          if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                            if (result !== 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                              {
                                message.warning(`${messages.warnings.payment.payment_multiple_check} ${filtredCurrencies[0]?.value}`);
                              }
                            } else {
                              requestPayment(selectedPaymentMethod, amount);
                            }
                          } else if (cart?.docType !== "Advance") {
                            processOrder();
                          }
                        }}
                      />
                    </Row>
                    {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
                      <Row style={{ padding: "0 1% 0 3.5%" }}>
                        <Col span={18}>
                          <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
                            {currenciesData.map((currency) => (
                              <Col span={8}>
                                <button
                                  id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                                  className="amt-dial-btn-market"
                                  onClick={() => handleCashPayment(currency.value)}
                                  disabled={currency.value === 999999}
                                  style={{
                                    color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                  }}
                                >
                                  {currency.value}
                                </button>
                              </Col>
                            ))}
                          </Row>
                        </Col>

                        <Col span={6}>
                          <Row style={{ padding: "0 0 7% 7%" }}>
                            <button className="amt-dial-btn-market" id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                              <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                            </button>
                          </Row>
                          <Row style={{ padding: "0 0 7% 7%" }}>
                            <button id="sm-amount-buttonClear" className="amt-dial-btn-market" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                              1,2,3...
                            </button>
                          </Row>
                          <Row style={{ padding: "0 0 0 7%" }}>
                            <button
                              id="sm-amount-buttonEnter"
                              className="amt-dial-btn-market2"
                              onClick={async () => {
                                if (
                                  selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                                  parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                                  posConfig?.showPaymentSummary === "Y" &&
                                  !(await showConfirm())
                                ) {
                                  return;
                                }
                                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                                const isGiftCardOrLoyalty =
                                  selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                  selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                  selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                                if (isGiftCardOrLoyalty) {
                                  if (parseFloat(Math.abs(cart.total)) > parseFloat(Math.abs(cart.paid))) {
                                    if (result !== 0) {
                                      message.warning(`${messages.warnings.payment.payment_multiple_check} ${filtredCurrencies[0]?.value}`);
                                    } else {
                                      requestPayment(selectedPaymentMethod, amount);
                                      if (parseFloat(Math.abs(cart.total)) > parseFloat(amount)) {
                                        if (CWHardwareController) {
                                          CWPoleDisplay(cart, "Show due payment", amount);
                                        } else {
                                          PoleDisplay(cart, "Show due payment", amount);
                                        }
                                      }
                                    }
                                  } else if (cart?.docType !== "Advance") {
                                    processOrder();
                                  }
                                }
                              }}
                            >
                              Enter
                            </button>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                        <Col span={6}>
                          <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
                            1
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
                            2
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
                            3
                          </button>
                        </Col>
                        <Col span={6}>
                          <button className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                            <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
                            4
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
                            5
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
                            6
                          </button>
                        </Col>
                        <Col span={6}>
                          <button
                            id="sm-amount-buttonClear"
                            className="amt-dial-btn-market"
                            style={{ background: themeJSON?.keyBoardColor }}
                            onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
                          >
                            1,2,3...
                          </button>
                        </Col>
                        <Col span={18}>
                          <Row gutter={[8, 6]}>
                            <Col span={8}>
                              <button id="sm-amount-button7" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                                7
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button8" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                                8
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                                9
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                                0
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button00" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("00")}>
                                00
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button." className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                                .
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6}>
                          <button
                            id="sm-amount-buttonEnter"
                            className="amt-dial-btn-market2"
                            style={{ background: themeJSON?.keyBoardColor }}
                            onClick={async () => {
                              if (
                                selectedPaymentMethod?.name?.toLowerCase() === "cash" &&
                                parseFloat(cart.paid) + parseFloat(amount) >= cart.total &&
                                posConfig?.showPaymentSummary === "Y" &&
                                !(await showConfirm())
                              ) {
                                return;
                              }

                              const isGiftCardOrLoyalty =
                                selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                              const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                              const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);
                              if (isGiftCardOrLoyalty) {
                                if (parseFloat(Math.abs(cart.total)) > parseFloat(cart?.paid)) {
                                  if (result !== 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash") {
                                    {
                                      message.warning(`${t("cash_payment_error")}`);
                                    }
                                  } else {
                                    setNumb(0);
                                    // Handle successful entry, e.g., submit the amount
                                    requestPayment(selectedPaymentMethod, amount);
                                  }
                                } else if (cart?.docType !== "Advance") {
                                  processOrder();
                                }
                              }
                            }}
                          >
                            Enter
                          </button>
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <LoadingScreen
              colorVariable={colorVariable}
              POSLogo={POSLogo}
              formattedDateTime={formattedDateTime}
              clock1={clock1}
              leftLoading={leftLoading}
              percent={percent}
              productCategoryPercentage={productCategoryPercentage}
              productPercentage={productPercentage}
              promotionPercentage={promotionPercentage}
            />
          </>
        )}

        <Drawer
          placement="left"
          width="20%"
          closable={false}
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={POSLogo} style={{ height: "2vw" }} />
              {/* <p style={{ fontSize: "2vw", paddingTop: "3vh", fontWeight: "500", color: "#2F3856", flex: 1, textAlign: "center" }}>Add Discount</p> */}
              <img
                src={Close}
                onClick={() => {
                  (setTillLink(false), setActiveInput("search"));
                  if (searchInputRef?.current) {
                    searchInputRef.current.focus();
                  }
                }}
                // style={{ marginLeft: "auto", paddingBottom: "5vh", cursor: "pointer" }}
                style={{
                  marginLeft: "auto",
                  // paddingBottom: "4vh",
                  paddingTop: "2vh",
                  cursor: "pointer",
                  width: "1.5vw",
                }}
              />
            </div>
          }
          bodyStyle={{ paddingTop: 0 }}
          visible={tillLink}
          onClose={() => {
            (setTillLink(false), setActiveInput("search"));
            if (searchInputRef?.current) {
              searchInputRef.current.focus();
            }
          }}
        >
          <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
            <Col span={24}>
              <Scrollbars style={{ height: "80vh" }}>
                <Row>
                  <Col
                    span={1}
                    style={{
                      cursor: "pointer",
                      display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    // onClick={tillUnlink}
                    onClick={confirmUnlink}
                    style={{
                      cursor: "pointer",
                      display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                      marginBottom: "2vh",
                    }}
                    span={22}
                  >
                    <img src={unlinkTillIcon} style={{ height: "2.5vh" }} alt="" />
                    <span
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "1.2em",
                        paddingLeft: "1vw",
                        color: "#0F0718",
                      }}
                    >
                      Unlink Till
                    </span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      cursor: "pointer",
                      display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={22}
                    onClick={async () => {
                      if (isOnline) {
                        if (cart.items.length === 0) {
                          localStorage.removeItem("lastUpdatedTime");
                          setTillLink(false);
                          setSyncLoad(true);
                          let tillData = JSON.parse(localStorage.getItem("tillData"));
                          const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillData.tillAccess.csBunit.b2cCustomer;
                          setCart({ ...cart, customer: defaultCustomer });
                          await processSync(tillData, setGlobalStore, "Full Sync");
                          setSyncLoad(false);
                          setGlobalStore({ percent: "0%" });
                          setGlobalStore({ productCategoryPercentage: "0" });
                          setGlobalStore({ productPercentage: "0" });
                          setGlobalStore({ promotionPercentage: "0" });
                          // window.location.reload();
                        } else {
                          message.error(`${messages.errors.sync.clear_cart_for_sync}`);
                        }
                      } else {
                        errorMessage(`${messages.errors.sync.sync_failed}`, `${messages.errors.sync.network_error}`);
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                      marginBottom: "2vh",
                    }}
                  >
                    <img src={SyncSide} style={{ height: "2vh" }} alt="" />
                    <span
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "1.2em",
                        paddingLeft: "1vw",
                        color: "#0F0718",
                      }}
                    >
                      Full Sync
                    </span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableAggregator === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={22}
                    onClick={() => {
                      history.push("/aggregator");
                    }}
                    style={{
                      cursor: "pointer",
                      display: posConfig?.enableAggregator === "Y" ? "block" : "none",
                      marginBottom: "2vh",
                    }}
                  >
                    <img src={openDrawerIcon} style={{ height: "2vh" }} alt="" />
                    <span
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: "1.2em",
                        paddingLeft: "1vw",
                        color: "#0F0718",
                      }}
                    >
                      Aggregator
                    </span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableAggregator === "Y" ? "block" : "none",
                    }}
                  />
                </Row>
              </Scrollbars>
            </Col>
            {/* ) : (
                ""
              )} */}
            {/* <Col span={24}>
                <Row>
                  <Col span={1} />
                  <Col style={{ cursor: "pointer" }} span={22}>
                    <img src={couponIcon} style={{ height: "2.5vh" }} alt="" />
                    <span style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2vw", paddingLeft: "1vw" }}>Coupon Code</span>
                  </Col>
                </Row>
              </Col> */}
            <Col
              span={24}
              style={{
                width: "80%",
                borderTop: "1px solid #929098",
                position: "absolute",
                bottom: "2.5vh",
                padding: "1vh 1vw",
              }}
            >
              <Row>
                <Col span={1} />

                <Col
                  style={{ cursor: "pointer", paddingTop: "1vh" }}
                  onClick={async () => {
                    // if (posConfigData?.posType === "PRD") {
                    const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
                    for (let i = 0; i < cookiesToDelete.length; i++) {
                      const cookie = cookiesToDelete[i];
                      const eqPos = cookie.indexOf("=");
                      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                      const domain = "domain=" + domainURL;
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
                    }
                    localStorage.removeItem("tillSession");
                    window.location.assign("/");
                    // }
                    handleCancel();
                  }}
                  span={20}
                >
                  <img src={Logout} alt="" />
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "1.2em",
                      color: "#0F0718",
                    }}
                  >
                    Logout
                  </span>
                </Col>
                <Col span={24} style={{ position: "absolute", bottom: "5vh", right: "0" }}>
                  <p style={{ color: "#0f071840", textAlign: "right", paddingRight: "1vw", fontSize: "0.6rem", fontWeight: 400 }}>v{version_number}</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Drawer>
        {open && showVirtualKeyboard && (
          <Drawer placement="bottom" closable={false} bodyStyle={{ paddingBottom: 0 }} onClose={onClose} height="47vh" visible={open && showVirtualKeyboard} mask={false}>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
              <img
                src={Close}
                onClick={() => {
                  setOpen(false);
                  setLayoutName("default");
                }}
                style={{
                  cursor: "pointer",
                  width: "1.5vw",
                }}
              />
            </div>
            <div style={{ padding: "0 5vw" }}>
              <Keyboard
                keyboardRef={(r) => {
                  keyboard.current = r;
                }}
                layoutName={layoutName}
                onChangeAll={(inputs) => {
                  updateKeyboardInputs(inputs);
                }}
                onKeyPress={onKeyPress}
                inputName={inputName}
                display={{
                  "{bksp}": "⌫",
                  "{numbers}": "123",
                  "{shift}": "⇧",
                  "{enter}": "Enter",
                  "{space}": "Space",
                  "{number}": "123",
                  "{caps}": "ABC",
                  "{small}": "abc",
                }}
                layout={{
                  shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} @ {space} . {enter}"],
                  numbers: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{caps} {space} {enter}"],
                  number: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{small} {space} {enter}"],
                  default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} @ {space} . {enter}"],
                }}
              />
            </div>
          </Drawer>
        )}
        <Drawer
          placement="bottom"
          height="75vh"
          title={null}
          closeIcon={null}
          className="filter"
          headerStyle={{ height: 0 }}
          bodyStyle={{ paddingTop: 0 }}
          visible={isProductsVisible}
          closable={true}
          onClose={closeProductPanel}
          footer={null}
        >
          <Row
            style={{
              paddingTop: isQtyUpdate ? 0 : "1.7%",
              width: "100%",
              paddingLeft: "1vw",
            }}
          >
            <ProductPanelSM
              checkIsManualWeight={checkIsManualWeight}
              setIsSearchProducts={setIsSearchProducts}
              getMoreProducts={getMoreProducts}
              productItems={productItems}
              setProductItems={setProductItems}
              selectProductInCart={selectProductInCart}
              setProductArray={setProductArray}
              isProductsFilter={isProductsFilter}
              getSearchedProducts={getSearchedProducts}
              productListCardRef={productListCardRef}
              productsDisplay={productsDisplay}
              setIsProductsVisible={setIsProductsVisible}
              pickProduct={pickProduct}
              filterDrawer={filterDrawer}
              setFilterDrawer={setFilterDrawer}
              productSearchInput={productSearchInput}
              setProductSearchInput={setProductSearchInput}
              setOpen={setOpen}
              keyboardType={keyboardType}
              setKeyboardType={setKeyboardType}
              productSearchInputRef={productSearchInputRef}
              clearProductSearchResults={clearProductSearchResults}
              productsData={productsData}
              isProductsVisible={isProductsVisible}
              productSearchRef={productSearchRef}
              handleSelectProduct={handleSelectProduct}
              productsList={productsList}
              setProductsList={setProductsList}
              setLayoutName={setLayoutName}
              productPanelSearchRef={productPanelSearchRef}
              setInputName={setInputName}
              keyboard={keyboard}
              setActiveInput={setActiveInput}
            />
          </Row>
        </Drawer>
        <ProductPanelSM
          checkIsManualWeight={checkIsManualWeight}
          setIsSearchProducts={setIsSearchProducts}
          getMoreProducts={getMoreProducts}
          productItems={productItems}
          setProductItems={setProductItems}
          selectProductInCart={selectProductInCart}
          setProductArray={setProductArray}
          isProductsFilter={isProductsFilter}
          getSearchedProducts={getSearchedProducts}
          productListCardRef={productListCardRef}
          productsDisplay={productsDisplay}
          isProductsVisible={isProductsVisible}
          setIsProductsVisible={setIsProductsVisible}
          pickProduct={pickProduct}
          filterDrawer={filterDrawer}
          setFilterDrawer={setFilterDrawer}
          productSearchInput={productSearchInput}
          setProductSearchInput={setProductSearchInput}
          setOpen={setOpen}
          keyboardType={keyboardType}
          setKeyboardType={setKeyboardType}
          productSearchInputRef={productSearchInputRef}
          clearProductSearchResults={clearProductSearchResults}
          productsData={productsData}
          productSearchRef={productSearchRef}
          handleSelectProduct={handleSelectProduct}
          productsList={productsList}
          setProductsList={setProductsList}
          setLayoutName={setLayoutName}
          productPanelSearchRef={productPanelSearchRef}
          setInputName={setInputName}
          keyboard={keyboard}
          setActiveInput={setActiveInput}
        />
        <GroupedProducts
          showCustomMix={showCustomMix}
          setShowCustomMix={setShowCustomMix}
          cart={cart}
          setCart={setCart}
          customMixItems={customMixItems}
          setCustomMixItems={setCustomMixItems}
          groupName={groupName}
          setGroupName={setGroupName}
          groupQty={groupQty}
          setGroupQty={setGroupQty}
          existingGroupItems={existingGroupItems}
          setExistingGroupItems={setExistingGroupItems}
          selectedCustomMix={selectedCustomMix}
          setSelectedCustomMix={setSelectedCustomMix}
          orderType={orderType}
          setOrderType={setOrderType}
          posSaleTypes={posSaleTypes}
          setPosSaleTypes={setPosSaleTypes}
          currenciesData={currenciesData}
          setCurrenciesData={setCurrenciesData}
          setActiveInput={setActiveInput}
          setProductStock={setProductStock}
        />
        <RetailModals {...props} />
      </>
    </Spin>
  );
};
export default SupermarketEstimate;
